<div *ngIf="!dismissed" id="body">
  <h3>
    <span>{{title}}</span>
    <digires-button icon="close" (onClick)="dismissed = true"></digires-button>
  </h3>
  <div id="content">
    <ng-content></ng-content>
  </div>
</div>
